import Vue from 'vue'
import firebase from 'firebase'
import Croppa from 'vue-croppa'
import VueScrollTo from 'vue-scrollto'

import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import 'vue-croppa/dist/vue-croppa.css'
import './assets/global_style.scss'
import '@mdi/font/css/materialdesignicons.css'

Vue.config.productionTip = false
Vue.use(Croppa)
Vue.use(VueScrollTo)

const config = {
  apiKey: 'AIzaSyARV7HtD9jn_scpuVCGZkdAqb0pCGUHyyQ',
  authDomain: 'micoma-cloud.firebaseapp.com',
  databaseURL: 'https://micoma-cloud.firebaseio.com',
  projectId: 'micoma-cloud',
  storageBucket: 'micoma-cloud.appspot.com',
  messagingSenderId: '295973702096',
  appId: '1:295973702096:web:bc90d8f6b30f91e789d1d5',
  measurementId: 'G-SWY78D41WH'
}
firebase.initializeApp(config)
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
